import { axiosInstance } from "../../../util/axios";

export const sendOtp = (phoneNumber) =>
  axiosInstance.post(
    `${process.env.REACT_APP_API_BASE_URL}${process.env.REACT_APP_SEND_OTP_API_URL}`,
    {
      MobileNumber: phoneNumber,
    },
    {
      headers: {
        Authorization: process.env.REACT_APP_AUTH_HEADER_TOKEN,
      },
    }
  );

export const verifyOtp = ({ otp, mobileNumber, callbackFn }) =>
  axiosInstance.post(
    `${process.env.REACT_APP_API_BASE_URL}${process.env.REACT_APP_VERIFY_OTP_API_URL}`,
    {
      MobileNumber: mobileNumber,
      pto: otp,
    },
    {
      headers: {
        Authorization: process.env.REACT_APP_AUTH_HEADER_TOKEN,
      },
    }
  );
